export const ProductsUtcOffsetActions = {
    GET_PRODUCT_UTC_OFFSET: 'GET_UTC_OFFSET',
    SET_PRODUCT_UTC_OFFSET: 'SET_PRODUCT_UTC_OFFSET',
} as const;

export type ProductsUtcOffsetReducer = Record<string /* guid */, number>